import { Dimensions } from 'react-native';

const MOBILE = 640;
const TABLET = 832;
const DESKTOP = 1024;
const UHD = 1920;

const BREAKPOINTS = [MOBILE, TABLET, DESKTOP, UHD];

/**
 * Returns a styled-components function
 *
 * @param propList - List of properties to convert
 */
export function convertPropsToStyle<T>(propList: string[]) {
  return function styledFunction(props: T) {
    const { width } = Dimensions.get('window');

    return propList.reduce((memo, cur) => {
      const value = props[cur];

      if (value) {
        memo += `${toKebabCase(cur)}: ${getProperty(width, value)};`;
      }

      return memo;
    }, '');
  };
}
/**
 * Returns the appropriate responsive property value
 *
 * @param width - Window width
 * @param value - Property value to convert
 */
export function getProperty(width: number, value: Property | Property[]) {
  if (!Array.isArray(value)) {
    return value;
  }

  let pos = 0;

  while (pos < value.length && width > BREAKPOINTS[pos]) {
    pos++;
  }
  return value[Math.max(0, pos - 1)];
}
/**
 * Converts camelCase string to Kebab case
 *
 * @param value - CamelCase string to convert
 */
export function toKebabCase(value: string) {
  return value.replace(/[A-Z]/g, word => '-' + word.toLowerCase());
}
export type Property = number | string;
